import styled from "styled-components"

export const Flex = styled.div`
display: flex;
justify-content: space-between;
`

export const FlexItem = styled.div`
flex-basis: ${props => props.width};
`